import { ReactComponent as LogoSvg } from '../../../asset/image/logo.svg'
import React from 'react'

export const Logo: React.FC = () => {
  return <LogoSvg />
}
